import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { FeatureFlagApi } from '../../api/FeatureFlagApi';
import { updateTableData } from '../../store/utilities/SliceDataHelper';

const initialState = {
  featureFlags: {
    data: {},
    totalCount: 0,
    currentPage: 1,
    searchKey: '',
    recordsPerPage: 0,
  },
};

//Feature flag thunks
//Gets the paginated feature flags
export const getFeatureFlags = createAsyncThunk(
  'featureFlags/getFeatureFlags',
  async (
    action: { page: number; limit: number; searchCode?: string; activeOnly?: boolean },
    thunkAPI
  ) => {
    return FeatureFlagApi.getFeatureFlags(action, thunkAPI.dispatch);
  }
);

// Fetches active-only feature flags for form dropdowns without writing to shared Redux state
export const getActiveFeatureFlags = createAsyncThunk(
  'featureFlags/getActiveFeatureFlags',
  async (action: { page: number; limit: number; searchCode?: string }, thunkAPI) => {
    return FeatureFlagApi.getFeatureFlags({ ...action, activeOnly: true }, thunkAPI.dispatch);
  }
);

//To create a feature flag
export const createFeatureFlag = createAsyncThunk(
  'featureFlags/createFeatureFlag',
  async (action: { request }, thunkAPI) => {
    return FeatureFlagApi.createFeatureFlag(action, thunkAPI.dispatch);
  }
);

//To update a feature flag
export const updateFeatureFlag = createAsyncThunk(
  'featureFlags/updateFeatureFlag',
  async (action: { request }, thunkAPI) => {
    return FeatureFlagApi.updateFeatureFlag(action, thunkAPI.dispatch);
  }
);

//To get feature flag details
export const getFeatureFlagDetails = createAsyncThunk(
  'featureFlags/getFeatureFlagDetails',
  async (action: { request }, thunkAPI) => {
    return FeatureFlagApi.getFeatureFlagDetails(action, thunkAPI.dispatch);
  }
);

//To delete feature flag(s)
export const deleteFeatureFlags = createAsyncThunk(
  'featureFlags/deleteFeatureFlags',
  async (action: { request }, thunkAPI) => {
    return FeatureFlagApi.deleteFeatureFlags(action, thunkAPI.dispatch);
  }
);

const featureFlagsSlice = createSlice({
  name: 'featureFlags',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getFeatureFlags.fulfilled, (state, action) => {
      if (!('error' in action.payload)) {
        return updateTableData(state.featureFlags, action.payload);
      }
      return state;
    });
  },
});

export default featureFlagsSlice.reducer;
